<template>
<!-- 控销专区 -->
    <div class="floor-style-erMei-design-1 floor-wsw" :id="data.block_name +c_index">
        <div class="head-wrap" v-if="data.value.title.value.text">
            <div class="left-head-warp">
                <el-image @click="$router.pushToTab(data.value.more.value.link)" fit="scale-down"
                :src="$util.img(data.value.titleImg.value.url)"></el-image>
                <h2 @click="$router.pushToTab(data.value.title.value.link.url)" :style="{ color: data.value.title.value.color }"
                >{{ data.value.title.value.text }}</h2>
                <span class="warp-title" :style="{ color: data.value.subTitle.value.color }" @click="$router.pushToTab(data.value.subTitle.value.link.url)">
                    {{ data.value.subTitle.value.text }}
                </span>
            </div>
            <div class="right-head-warp">
                <div @click="$router.pushToTab(data.value.more.value.link.url)" :style="{ color: data.value.more.value.color }">
                    <span :style="{ color: data.value.more.value.color }">{{ data.value.more.value.text }}</span>
                    <i :style="{ color: data.value.more.value.color }" class="icon el-icon-arrow-right"></i>
                </div>
            </div>
        </div>
        <div class="body-wrap">
            <div class="left-swiper">
                <el-carousel height="280px" arrow="never">
                    <template v-for="(item,index) in carouselsNumIsTwoUseCopy(data.value.bannerImgs)">
                        <el-carousel-item>
                            <img alt :src="$img(item.value.url)" @click.stop="$router.pushToTab(item.value.link.url)"/>
                        </el-carousel-item>
                    </template>
                </el-carousel>
            </div>
            <div class="right-goods-list">
                <template v-for="(item, index) in data.value.goodsList.value.list">
                    <template v-if="index <= 2">
                        <div :style="{backgroundImage: 'url(' + data.value.goodsBgImg.value.url + ')'}" class="hoverBox hoverBoder">
                            <goodsListItem :goods="item" :upDownLayout="true"></goodsListItem>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { onTip } from "@/utils/tips"
import goodsPrice from "@/components/goods-price/goods-price.vue"
import shareCounter from "@/components/shareCounter.vue"
import goodsListItem from "@/components/goods-list-item/goods-list-item.vue"
export default {
    name: "floor-style-erMei-design-1",
    components: {
        goodsPrice,
        shareCounter,
        goodsListItem
    },
    props: {
        data: {
            type: Object
        },
        c_index: {
            type: Number || String
        }
    },
    data() {
        return {
            number : 1
        }
    },
    watch: {

    },
    created() {},
    computed: {
        ...mapGetters(["defaultGoodsImage", "token", "storeWithoutAuthority"]),
        /*
         * 由于只有两个Carousel-Item的时候滑动方向不是始终一个方向，但是超过2个的时候就是一个方向了，
         * 所以我们可以对data（用于loop循环的数据）进行改造，假设当前data =[“1”,“2”],
         * 那么我们需要将该data改造成[“2”,“1”,“2”,“1”],即在首尾分别添加尾 首的数据，实现时，
         * 我们可以先设置初始化时的默认幻灯片索引为1，那么它就能按顺序，1212的滑动了，且方向也是相同的了
         * */
        carouselsNumIsTwoUseCopy() {
            return arr => {
                let arrayResult = [...arr]
                if (arr.length === 2) {
                    let copyArr = arr.slice(0)
                    arrayResult.push(...copyArr)
                }
                return arrayResult
            }
        }
    },
    methods: {
        // goSku(skuId) {
        //     this.$router.pushToTab('/sku?id=' + skuId)
        // },
        goSku(item) {
            if (!this.token) {
                this.$router.pushToTab("/login")
                return
            }
            if (onTip(item.sale_control.view_price,item.sale_control.is_member_by,this,item.sale_control.not_buy_msg)) return

            this.$router.pushToTab("/sku?id=" + item.sku_id)
        },
        imageError(index) {
            this.data.value.goodsList.value.list[index].sku_image = this.defaultGoodsImage
        },
        upnumber(val) {
            this.number = val
        },
        // 加入购物车
        joinCart(item) {
            if (!this.$store.getters.token) {
                this.$router.pushToTab("/login")
                return
            }
            this.$store
                .dispatch("cart/add_to_cart", {
                    site_id: item.site_id,
                    sku_id: item.sku_id,
                    num: this.number
                })
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "加入购物车成功",
                            type: "success"
                        })
                    }
                })
                .catch(err => {
                    if (err.message === "token不存在") {
                        this.$router.pushToTab("/login")
                    } else {
                        this.$message.error(err.message);
                        if(typeof err.data === 'number'){
                            if(err.data > 0){
                                this.$refs['shareCounter'+index][0].upnumber(err.data);
                                this.$message({
                                    message: "当前数量已更改为可购买数量，请重试加入购物车",
                                    type: "success"
                                });
                            }else{
                                window.location.reload();
                            }
                        }
                    }
                })
        }
    }
}
</script>

<style lang="scss">
.el-carousel__item img {
    height: 100%;
    width: 100%;
    object-fit: contain;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
}

.floor-style-erMei-design-1 {
    background: #fff;
    margin-top: 20px;

    .head-wrap {
        height: 50px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
        border-bottom: 1px solid #f9f9f9;
    }

    .head-wrap {
        .left-head-warp {
            text-align: center;
            display: flex;
            align-items: center;
            .el-image {
                width: 30px;
                height: 30px;
            }
            h2 {
                margin-left: 10px;
                display: inline-block;
                vertical-align: middle;
                text-align: center;
                font-size: 18px;
                line-height: 30px;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .warp-title{
                margin-left: 10px;
            }
        }

        span {
            color: #b0b0b0;
            font-size: 14px;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .el-icon-arrow-right {
            font-size: 16px;
        }
    }

    .body-wrap {
        margin-top: 10px;
        display: flex;
        align-items: flex-start;
        .left-swiper {
            width: 380px;
            box-sizing: border-box;
        }

        .right-goods-list {
            box-sizing: border-box;
            width: calc(100% - 380px);
            padding: 0 12px 12px 12px;
            box-sizing: border-box;
            display: flex;
            gap: 12px;
            >div{
                width: calc((100% - 24px) / 3);
                border: 1px solid #f9f9f9;
                box-sizing: border-box;
                padding: 12px;
                box-sizing: border-box;
                border-radius: 12px;
                transition: all 0.2s linear;
                background-color: white;
                &:hover {
                    z-index: 2;
                    -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                    -webkit-transform: translate3d(0, -2px, 0);
                    transform: translate3d(0, -2px, 0);
                    border: 1px solid #dddddd6e;
                }
            }
        }

        .goods-list {
            height: 100%;
            display: flex;
            gap: 10px;

            li {
                position: relative;
                width: 190px;
                height: 280px;
                border: 1px solid #f9f9f9;
                width: calc((100% - 30px) / 4);
                padding: 12px;
                background-image: url("https://scjuchuang.oss-cn-chengdu.aliyuncs.com/files/PNG/2023-11-28/1701155200000_30.png?x-oss-process=style/normal");
                cursor: pointer;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                gap: 2px;

                >div{
                    flex-shrink: 0;
                }
                .img-wrap {
                    box-sizing: border-box;
                    width: 100%;
                    height: 140px;
                    //margin: 30px;
                    text-align: center;
                    line-height: 140px;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }

                .goods-name {
                    color: #333;
                    text-align: center;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    width: 100%;
                    font-size: 14px;
                    font-weight: 600;
                    height: 30px;
                    line-height: 30px;
                    display: block;
                    float: left;
                }

                .goods-attr {
                    text-align: center;
                    line-height: normal;
                    width: 100%;
                    color: rgb(102, 102, 102);
                    font-size: 14px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }

                .price {
                    line-height: normal;
                    color: #666;
                    font-size: 18px;
                    position: absolute;
                    font-weight: 600;
                    left: 15px;
                    bottom: 4px;
                }

                .market-price {
                    position: absolute;
                    left: 110px;
                    bottom: 5px;
                    line-height: normal;
                    color: #999;
                    font-size: 14px;
                }
            }
        }
    }

    .el-carousel__indicators--horizontal {
        display: none;
    }
}
.cart-layout {
    display: flex;
    justify-content: center;
    align-items: center;

    .el-input-number--mini {
        width: 85px !important;
    }

    .cart-num {
        margin-right: 10px;
        position: relative;
        width: 30%;
        border-radius: 4px;
        display: flex;
        border: 1px solid #ccc;
        justify-content: center;
        align-items: center;

        span {
            z-index: 1;
            position: absolute;
            cursor: pointer;
            width: 20px;
            text-align: center;
        }

        span:first-child {
            left: 0;
        }

        span:last-child {
            right: 0;
        }

        .number {
            .el-input {
                .el-input__inner {
                    text-align: center;
                }
            }
        }
    }

    .cart-add {
        font-size: 12px;
        margin-left: 5px;
        cursor: pointer;
        background: $base-color;
        color: $base-color-whtie;
        border-radius: 15px;
        padding: 2px 10px;
    }
    .ban{
        font-size: 12px;
        margin-left: 5px;
        cursor: not-allowed;
        background:#dddddd6e;
        color: $base-color-whtie;
        border-radius: 15px;
        padding: 2px 10px;
    }
}
</style>
